import angular from 'angular';

import RwGamePosterComponent from './rw-game-poster-component';

export default angular
  .module('rw-game-poster', ['rw-date', 'rw-currency'])
  .component('rwGamePoster', RwGamePosterComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-game-poster/rw-game-poster-module.js